import reducer from './reducers';
import * as profileActions from './actions';
import * as profileSelectors from './selectors';

export { profileActions, profileSelectors };
export default reducer;